import { render } from "./installPwa.vue?vue&type=template&id=db500d22"
import script from "./installPwa.vue?vue&type=script&lang=js"
export * from "./installPwa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__